var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradeHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57633 6.87952C5.73674 5.11687 7.72962 3.96145 10 3.96145C13.5906 3.96145 16.5 6.87952 16.5 10.4807C16.5 14.0819 13.5906 17 10 17C6.40944 17 3.5 14.0819 3.5 10.4807M8.20052 7.20843H4.00453V3",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeHistory);
export default __webpack_public_path__ + "static/media/tradeHistory.45037d88e52c345a41352fe86a0ebebb.svg";
export { ForwardRef as ReactComponent };